import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardService } from '../dashboard.service';

@Component({
	selector: 'app-last-transactions',
	templateUrl: './last-transactions.component.html',
	styleUrls: ['./last-transactions.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class LastTransactionsComponent implements OnInit {

	transactionCount = 0;

	constructor(private dashService: DashboardService) { }

	ngOnInit() {

		this.dashService.getTotalTransactions('pendente').subscribe((data: number) => {
			this.transactionCount = data;
		});

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/last-transactions/last-transactions.component.ts